export default "<router-outlet></router-outlet>\n<notifier-container></notifier-container>"